import React from 'react'
// import { Route } from 'react-router-dom'
import Helmet from 'react-helmet-async'
import { compose } from 'react-apollo'


import { getUserFavouritesByType } from '../utils/selectors'
import GetUser from '../hocs/queries/GetUser'
import WithUploads from '../hocs/WithUploads'
import WithUploadModal from '../hocs/WithUploadModal'
import Breadcrumb from '../components/Breadcrumb'
import Hero from '../components/Hero'

import RecentlyDeletedFiles from './RecentlyDeletedFiles'

class DeletedFilesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shouldRerender: 'foo'

    }
  }
  componentDidMount() {
    if (this.props.location.state) {
      this.props.uploadModal.open('/', '', null)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state && this.props.location.state) {
      this.props.uploadModal.open('/', '', null)
    }
  }
manualRerender = (value) => {
  this.setState({
    shouldRerender: `unel${Math.floor(Math.random() * 10)}`
  })
}
render() {
  const favourites = getUserFavouritesByType(this.props.user)
  return (
      <>
        <Helmet>
          <title>Deleted Files</title>
        </Helmet>
        <main className='main files-share'>
          <Hero
            src='ph.hero.projects.jpg'
            alt='Deleted Files'
            subtitle='Deleted Files'
          >

            <Breadcrumb items={[
              {
                href: `/files`,
                name: 'Files'
              },
              {
                href: `/files/myfiles`,
                name: 'Deleted Files'
              }
            ]} />
          </Hero>


          <RecentlyDeletedFiles match={this.props.match}
            location={this.props.location}
            uploadModal={this.props.uploadModal}
            uploads={this.props.uploads}
            project={this.props.project}
            setProjectIdAndFolderId={this.props.uploads.actions.setProjectIdAndFolderId}
            fileFavourites={favourites.file || []}
            folderFavourites={favourites.folder || []}
            userId={this.props.user.id}
            recentlyDeleted={true}
            shouldRerender={this.state.shouldRerender}
            perPage={100}
          />
        </main>
      </>
  )
}
}

export default compose(
  WithUploads,
  WithUploadModal,
  GetUser
)(DeletedFilesPage)
